__webpack_require__.p = "/static/core/frontend/";